import { render, staticRenderFns } from "./MultiMessage.vue?vue&type=template&id=601d896c&scoped=true&"
import script from "./MultiMessage.vue?vue&type=script&lang=js&"
export * from "./MultiMessage.vue?vue&type=script&lang=js&"
import style0 from "./MultiMessage.vue?vue&type=style&index=0&id=601d896c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d896c",
  null
  
)

export default component.exports